import React from 'react'
import '../styles/footer.scss'

const Footer = () => {
    return (
        <footer>
            <div>
                <h1>TechyStar</h1>
                <p>@all right reserved</p>
            </div>

            <div>
                <h5>Follow Us</h5>
                <div>
                    <a href="https://www.linkedin.com/in/sachin-singh-040290218/" target={"blank"}>
                        Linkedin
                    </a>
                    <a href="https://www.instagram.com/__sachin__singh_1/" target={"blank"}>
                        Instagram
                    </a>
                    <a href="https://github.com/sachinsingh2020" target={"blank"}>
                        Github
                    </a>
                </div>
            </div>
        </footer>
    )
}

export default Footer
